import React, { FC, memo, useCallback, useState, useEffect } from "react";
import Scene from "Components/Scene";

import { useSelector, useDispatch } from "react-redux";
import { setCurrentStop } from "Containers/Stops";
import { areEqualShallow } from "Utils/areEqual";

import { resetAudio } from "Containers/AudioPlayer/AudioPlayerActions";
import GoogleMap from "../../map/GoogleMap";

interface Props {
  currentStop: number;
  locId: any;
  mapObj: GoogleMap;
}

const SceneContainer: FC<Props> = memo((props: Props) => {
  const { currentStop, locId, mapObj } = props;
  const Dispatch = useDispatch();
  const stops = useSelector((store: any) => store.stops);
  const [scene, setScene] = useState(true);

  const setAudio = () => Dispatch(resetAudio());

  const setCurrentStopDispatch = useCallback(
    (stopId: number) => {
      Dispatch(setCurrentStop(stopId));
    },
    [Dispatch]
  );

  // Find returns any matching element
  const stop = stops.find((s) => s.id === currentStop);

  useEffect(() => {
    const bottomNav = document.getElementById("bottomNavTitle");
    if (stop && bottomNav) {
      bottomNav.focus();
    }
  }, [stop]);

  if (!stop) return null;

  return (
    <Scene
      stop={stop}
      setCurrentStop={setCurrentStopDispatch}
      scene={scene}
      setScene={setScene}
      resetAudio={setAudio}
      locId={locId}
      mapObj={mapObj}
    />
  );
}, areEqualShallow);
export default SceneContainer;
